import firebase from "firebase";
import "@firebase/firestore";
import ReduxSagaFirebase from "redux-saga-firebase";
import "firebase/messaging";
import "firebase/auth";
import { SSO_TYPE_SAML } from "./helper/constants";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// const publicKey = process.env.REACT_APP_VAPID;

export let firebaseApp = firebase.app.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

const rsf = new ReduxSagaFirebase(firebaseApp);

export const signInWithGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await firebase.auth().signInWithPopup(provider);
  const idToken = await result.user.getIdToken();
  return {
    idToken,
    email: result.user.email
  };
};

export const signInWithMicrosoft = async () => {
  const provider = new firebase.auth.OAuthProvider("microsoft.com");
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await firebase.auth().signInWithPopup(provider);
  const idToken = await result.user.getIdToken();
  return {
    idToken,
    email: result.user.email
  };
};

// per protocol, so org.type decides between SAML and OIDC.
export const signInWithSsoOrg = async ({ providerId, type }) => {
  const provider =
    type === SSO_TYPE_SAML
      ? new firebase.auth.SAMLAuthProvider(providerId)
      : new firebase.auth.OAuthProvider(providerId);
  const result = await firebase.auth().signInWithPopup(provider);
  const idToken = await result.user.getIdToken();
  return {
    idToken,
    email: result.user.email
  };
};

export const linkSsoWithPassword = async ({ email, password, pendingCred }) => {
  const result = await firebase.auth().signInWithEmailAndPassword(email, password);
  if (pendingCred) {
    await result.user.linkWithCredential(pendingCred);
  }
  const idToken = await result.user.getIdToken();
  return { idToken };
};

export default rsf;
